import React from 'react';
import './style.css';
import ArrowRight from '../../img/ui/ui-arrow-top-right.svg';
import Button from '../button/button';

const InfoSection = ({
  paragraphs = [],
  imageSrc,
  imageAlt,
  className = '',
  buttonText,
  buttonLink,
  target = '_self' 
}) => {
  return (
    <div className={`price-wrapper ${className}`}>
      <div className="info-section__text">
        {paragraphs.map((text, index) => (
          <p key={index}>{text}</p>
        ))}

        {buttonText && buttonLink && (
          <div className="cta-button">
            <Button
              buttonText={buttonText}
              link={buttonLink}
              target={target}
              icon={ArrowRight}
            />
          </div>
        )}
      </div>

      <div className="payment-block">
        <img className="info-section__image" src={imageSrc} alt={imageAlt} />
      </div>
    </div>
  );
};

export default InfoSection;
